const S3_IMAGE_BASE = 'https://bellhopt-public.s3.us-west-1.amazonaws.com';

const UNSPLASH = {
  hero: `${S3_IMAGE_BASE}/host_banner.jpeg`,

  heroMobile: `${S3_IMAGE_BASE}/host_banner.jpeg`,


  services: {
    privateChef: `${S3_IMAGE_BASE}/private-chef.jpg`,
    restaurantReservations: `${S3_IMAGE_BASE}/restaurant-reservations.jpg`,
    ivTherapy: `${S3_IMAGE_BASE}/wellness-therapy.jpg`,
    airportTransfer: `${S3_IMAGE_BASE}/airport-pickup.jpg`,
    arrivalEvent: `${S3_IMAGE_BASE}/arrival-event.jpg`,
    groceryDelivery: `${S3_IMAGE_BASE}/grocery-delivery.jpg`,
    massage: `${S3_IMAGE_BASE}/massage.jpg`,
    customRequest: `${S3_IMAGE_BASE}/other.jpg`,
  },

  lifestyle: {
    luxuryInterior: `${S3_IMAGE_BASE}/early-check-in.jpg`,
    poolside: `${S3_IMAGE_BASE}/arrival-event.jpg`,
    kitchen: `${S3_IMAGE_BASE}/grocery-delivery.jpg`,
  },

  thumbs: {
    restaurant: `${S3_IMAGE_BASE}/restaurant-reservations.jpg`,
    restaurant2: `${S3_IMAGE_BASE}/private-chef.jpg`,
    coffee: `${S3_IMAGE_BASE}/restaurant-reservations.jpg`,
    coffee2: `${S3_IMAGE_BASE}/restaurant-reservations.jpg`,
    trail: `${S3_IMAGE_BASE}/arrival-event.jpg`,
    market: `${S3_IMAGE_BASE}/grocery-delivery.jpg`,
  },
};

export default UNSPLASH;
